import { Preferences } from '@capacitor/preferences';

const KEY = 'trauvo_today_suggestion';
const GROUP = 'group.com.trauvo.shared';

type WidgetSuggestion = {
  id: number | string;
  title: string;
  subtitle?: string;
};

async function configureGroupIfSupported() {
  const anyPrefs = Preferences as any;
  if (typeof anyPrefs.configure === 'function') {
    await anyPrefs.configure({ group: GROUP });
  }
}

export async function saveTodaySuggestionForWidget(s: WidgetSuggestion) {
  try {
    await configureGroupIfSupported();

    const payload = {
      id: s.id,
      title: s.title,
      subtitle: s.subtitle || '',
      date: new Date().toISOString().slice(0, 10),
    };

    await Preferences.set({
      key: KEY,
      value: JSON.stringify(payload),
    });
  } catch (err) {
    console.warn('[Trauvo][WidgetSync] Failed to save suggestion for widget', err);
  }
}
